// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/modules/shared/common-styles.scss
// module id = 1636
// module chunks = 23